import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import TournamentPlayerListBreadcrumbTitle from '../components/TournamentPlayerListBreadcrumbTitle'
import { LoadingSpinner } from '../../common'

const TournamentPlayerListBreadcrumbTitleContainer = ({
  loading, loaded, ...rest
}) => {
  if (loading) {
    return <LoadingSpinner />
  }

  return loaded && <TournamentPlayerListBreadcrumbTitle {...rest} />
}

TournamentPlayerListBreadcrumbTitleContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
}

const mapStateToProps = ({
  tournament: {
    summary: {
      loading,
      loaded,
      data: tournament,
    },
  },
}) => ({
  loading,
  loaded,
  tournament,
})

export default connect(mapStateToProps)(TournamentPlayerListBreadcrumbTitleContainer)
